module.exports = __webpack_public_path__ + "img/list4.096a4374.png";